import POISEReport from './POISEReportTemplate';
import SMARTReport from './SMARTReportTemplate';

export default [POISEReport, SMARTReport];
